MessageFormat.locale.fr=function(n){return n===0||n==1?"one":"other"}
